import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";

import Draggable from "react-draggable";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

function fmtNumero(value, casas = 2) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const n = Number(value);

  if (!Number.isFinite(n)) {
    return "-";
  }

  return n.toLocaleString("pt-PT", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

function fmtPercentagem(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const n = Number(value);

  if (!Number.isFinite(n)) {
    return "-";
  }

  return `${n.toLocaleString("pt-PT", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}%`;
}

function casasValor(metrica, modo) {
  const m = String(metrica || "")
    .trim()
    .toUpperCase();

  const md = String(modo || "")
    .trim()
    .toUpperCase();

  if (m === "CLIENTES") {
    return md === "MEDIA" ? 3 : 0;
  }

  if (m === "QTD") return 0;
  if (m === "EUROS") return 2;
  if (m === "LITROS") return 3;

  return 2;
}

const thStyle = {
  textAlign: "left",
  padding: "10px 8px",
  fontSize: 12,
  color: "#7b809a",
  fontWeight: 700,
};

const tdStyle = {
  padding: "10px 8px",
  fontSize: 13,
  borderBottom: "1px solid #eeeeee",
};

export default function DialogObjetivoV2DashboardDetalhe({ open, onClose, objetivo }) {
  const [loading, setLoading] = useState(false);
  const [detalhe, setDetalhe] = useState(null);
  const [erro, setErro] = useState("");

  useEffect(() => {
    if (!open || !objetivo?.id) {
      setDetalhe(null);
      setErro("");
      return;
    }

    let ativo = true;

    const carregar = async () => {
      setLoading(true);
      setErro("");

      try {
        const [data, err] = await handleApi(
          api.post("Comercial/SelObjetivoV2DashboardDetalhe", {
            id: objetivo.id,
          })
        );

        if (!ativo) return;

        if (err) {
          setDetalhe(null);
          setErro(err);
          return;
        }

        setDetalhe(data || null);
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [open, objetivo?.id]);

  const casas = useMemo(
    () => casasValor(detalhe?.objetivo?.metrica, detalhe?.objetivo?.patamares_modo),
    [detalhe?.objetivo?.metrica, detalhe?.objetivo?.patamares_modo]
  );

  const submarcas = Array.isArray(detalhe?.submarcas) ? detalhe.submarcas : [];

  const equipas = Array.isArray(detalhe?.equipas) ? detalhe.equipas : [];

  const vendedores = Array.isArray(detalhe?.vendedores) ? detalhe.vendedores : [];

  const nomeObjetivo = detalhe?.objetivo?.nome || objetivo?.objetivo_nome || "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          width: {
            xs: "calc(100% - 16px)",
            sm: "calc(100% - 48px)",
          },
          maxHeight: "92vh",
        },
      }}
    >
      <DialogTitle className="draggable-dialog-title" sx={{ cursor: "move" }}>
        <MDTypography variant="h5">{nomeObjetivo || "Detalhe do objetivo"}</MDTypography>

        <MDTypography variant="button" color="text" display="block" mt={0.5}>
          Detalhe por vendedor
        </MDTypography>
      </DialogTitle>

      <DialogContent dividers>
        {loading && (
          <MDBox py={4} display="flex" justifyContent="center">
            <CircularProgress />
          </MDBox>
        )}

        {!loading && erro && (
          <MDBox py={2}>
            <MDTypography variant="button" color="error">
              {erro}
            </MDTypography>
          </MDBox>
        )}

        {!loading && !erro && detalhe && (
          <>
            {submarcas.length > 0 && (
              <MDBox mb={3}>
                <MDTypography variant="button" color="text" display="block" mb={1}>
                  Submarcas selecionadas
                </MDTypography>

                <MDBox display="flex" flexWrap="wrap" gap={1}>
                  {submarcas.map((s) => (
                    <MDBox
                      key={s.refsubmarca}
                      sx={{
                        px: 1.5,
                        py: 0.75,
                        border: "1px solid #d9d9d9",
                        borderRadius: 1,
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <MDTypography
                        variant="button"
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                        }}
                      >
                        {s.submarca || s.refsubmarca}
                      </MDTypography>
                    </MDBox>
                  ))}
                </MDBox>
              </MDBox>
            )}

            {equipas.length > 0 && (
              <MDBox mb={3}>
                <MDTypography variant="button" color="text" display="block" mb={1}>
                  Equipa
                </MDTypography>

                <MDBox
                  sx={{
                    overflowX: "auto",
                    maxWidth: "100%",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      minWidth: 600,
                    }}
                  >
                    <thead>
                      <tr>
                        <th style={thStyle}>Equipa</th>
                        <th style={thStyle}>Objetivo</th>
                        <th style={thStyle}>Real</th>
                        <th style={thStyle}>Dif.</th>
                        <th style={thStyle}>%</th>
                      </tr>
                    </thead>

                    <tbody>
                      {equipas.map((row) => (
                        <tr key={`equipa-${row.referencia}`}>
                          <td style={tdStyle}>{row.nome || row.referencia}</td>

                          <td style={tdStyle}>{fmtNumero(row.objetivo, casas)}</td>

                          <td style={tdStyle}>
                            <strong>{fmtNumero(row.resultado, casas)}</strong>
                          </td>

                          <td
                            style={{
                              ...tdStyle,
                              color:
                                Number(row.diferenca) < 0
                                  ? "#f44335"
                                  : Number(row.diferenca) > 0
                                  ? "#4caf50"
                                  : undefined,
                            }}
                          >
                            {fmtNumero(row.diferenca, casas)}
                          </td>

                          <td style={tdStyle}>{fmtPercentagem(row.atingimento_percentagem)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </MDBox>
              </MDBox>
            )}

            <MDBox mb={3}>
              <MDTypography variant="button" color="text" display="block" mb={1}>
                Individuais — detalhe por vendedor
              </MDTypography>

              <MDBox
                sx={{
                  overflowX: "auto",
                  maxWidth: "100%",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    minWidth: 650,
                  }}
                >
                  <thead>
                    <tr>
                      <th style={thStyle}>Vendedor</th>
                      <th style={thStyle}>Objetivo</th>
                      <th style={thStyle}>Real</th>
                      <th style={thStyle}>Dif.</th>
                      <th style={thStyle}>%</th>
                    </tr>
                  </thead>

                  <tbody>
                    {vendedores.map((row) => (
                      <tr key={`vendedor-${row.referencia}`}>
                        <td style={tdStyle}>{row.nome || row.referencia}</td>

                        <td style={tdStyle}>{fmtNumero(row.objetivo, casas)}</td>

                        <td style={tdStyle}>
                          <strong>{fmtNumero(row.resultado, casas)}</strong>
                        </td>

                        <td
                          style={{
                            ...tdStyle,
                            color:
                              Number(row.diferenca) < 0
                                ? "#f44335"
                                : Number(row.diferenca) > 0
                                ? "#4caf50"
                                : undefined,
                          }}
                        >
                          {fmtNumero(row.diferenca, casas)}
                        </td>

                        <td style={tdStyle}>{fmtPercentagem(row.atingimento_percentagem)}</td>
                      </tr>
                    ))}

                    {vendedores.length === 0 && (
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            ...tdStyle,
                            textAlign: "center",
                            color: "#7b809a",
                          }}
                        >
                          Sem objetivos individuais.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </MDBox>
            </MDBox>

            <MDBox>
              <MDTypography variant="button" color="text" display="block" mb={1}>
                Total Geral
              </MDTypography>

              <MDBox
                sx={{
                  overflowX: "auto",
                  maxWidth: "100%",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    minWidth: 600,
                  }}
                >
                  <thead>
                    <tr>
                      <th style={thStyle}>Tipo</th>
                      <th style={thStyle}>Objetivo</th>
                      <th style={thStyle}>Real</th>
                      <th style={thStyle}>Dif.</th>
                      <th style={thStyle}>%</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td
                        style={{
                          ...tdStyle,
                          fontWeight: 700,
                        }}
                      >
                        Total Geral
                      </td>

                      <td
                        style={{
                          ...tdStyle,
                          fontWeight: 700,
                        }}
                      >
                        {fmtNumero(detalhe?.total?.objetivo, casas)}
                      </td>

                      <td
                        style={{
                          ...tdStyle,
                          fontWeight: 700,
                        }}
                      >
                        {fmtNumero(detalhe?.total?.resultado, casas)}
                      </td>

                      <td
                        style={{
                          ...tdStyle,
                          fontWeight: 700,
                          color:
                            Number(detalhe?.total?.diferenca) < 0
                              ? "#f44335"
                              : Number(detalhe?.total?.diferenca) > 0
                              ? "#4caf50"
                              : undefined,
                        }}
                      >
                        {fmtNumero(detalhe?.total?.diferenca, casas)}
                      </td>

                      <td
                        style={{
                          ...tdStyle,
                          fontWeight: 700,
                        }}
                      >
                        {fmtPercentagem(detalhe?.total?.atingimento_percentagem)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </MDBox>
            </MDBox>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
